import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { BrandingService } from '../services/user/branding.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UnauthorizedComponent implements OnInit {
  logoPath: string = null as any;

  constructor(private brandingService: BrandingService) {}

  ngOnInit(): void {
    this.brandingService.getLogoPath().subscribe({
      next: (logo: string) => this.logoPath = logo,
      error: () => this.logoPath = './assets/alight_worklife_logo_black.svg'
    });
  }
}
